import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'
import { MusicPage } from './pages/MusicPage'
import { DemoArchivePage } from './pages/DemoArchivePage'
import { SongPage } from './pages/SongPage'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="music" element={<MusicPage />} />
        <Route path="music/demo-archive" element={<DemoArchivePage />} />
        <Route path="music/:slug" element={<SongPage />} />
        <Route path="vault" element={<Navigate to="/music" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
